
import { Component, Vue } from 'vue-property-decorator'
import {
  CreatePipeDiameter,
  UpdatePipeDiameter,
  DeletePipeDiameter,
  ListPipeDiameters
} from '@/api/baseData'
import { IPipeDiameter } from '@/api/types'

@Component({
  name: 'PipeDiameterTab'
})
export default class extends Vue {
  private list: IPipeDiameter[] = []
  private listLoading = false

  private dialogFormVisible = false
  private dialogStatus = ''
  private temp :IPipeDiameter = {
    id: -1,
    name: '',
    size: 0,
    price: 0,
  }

  private rules = {
    // name: [{ required: true, message: '请输入管径名称', trigger: 'blur' }],
    size: [{ required: true, message: '请输入管径尺寸', trigger: 'blur' }],
    price: [{ required: true, message: '请输入管径价格', trigger: 'blur' }]
  }

  created() {
    this.getList()
  }

  private async getList() {
    this.listLoading = true
    try {
      const { data } = await ListPipeDiameters()
      this.list = data || []
    } catch (error) {
      console.error('获取管径列表失败', error)
    } finally {
      this.listLoading = false
    }
  }

  private resetTemp() {
    this.temp = {
      id: -1,
      name: '',
      size: 0,
      price: 0,
    }
  }

  private handleCreate() {
    this.resetTemp()
    this.dialogStatus = 'create'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as any).clearValidate()
    })
  }

  private async createData() {
    (this.$refs.dataForm as any).validate(async(valid: boolean) => {
      if (valid) {
        try {
          await CreatePipeDiameter(this.temp)
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '创建管径成功',
            type: 'success',
            duration: 2000
          })
          this.getList()
        } catch (error) {
          console.error('创建管径失败', error)
        }
      }
    })
  }

  private handleUpdate(row: any) {
    this.temp = Object.assign({}, row)
    this.dialogStatus = 'update'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as any).clearValidate()
    })
  }

  private async updateData() {
    (this.$refs.dataForm as any).validate(async(valid: boolean) => {
      if (valid) {
        const tempData = Object.assign({}, this.temp)
        try {
          if (tempData.id !== undefined) {
            const updateData = {
              id: Number(tempData.id),
              name: tempData.name,
              size: tempData.size,
              price: tempData.price
            }
            await UpdatePipeDiameter(updateData)
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新管径成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          }
        } catch (error) {
          console.error('更新管径失败', error)
        }
      }
    })
  }

  private async handleDelete(row: any) {
    this.$confirm('确认删除该管径?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async() => {
      try {
        await DeletePipeDiameter({ id: row.id })
        this.$notify({
          title: '成功',
          message: '删除管径成功',
          type: 'success',
          duration: 2000
        })
        this.getList()
      } catch (error) {
        console.error('删除管径失败', error)
      }
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消删除'
      })
    })
  }
}
